import { render, staticRenderFns } from "./Reminders.vue?vue&type=template&id=76939834"
import script from "./Reminders.ts?vue&type=script&lang=ts&external"
export * from "./Reminders.ts?vue&type=script&lang=ts&external"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports